import styles from './video.module.less';

const Video = ({ description, videoText, video }) => {
    const src = video?.fields?.file?.url;
    if (!src) {
        return null;
    }

    return (
        <div className={styles.videoContainer}>
            <video title={description} controls className={styles.video}>
                <source src={src} type="video/mp4" />
                Beklager, men browseren din støtter ikke å vise videoen.
            </video>
            <p className={styles.videoText}>{videoText}</p>
        </div>
    );
};

export default Video;
